import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastService } from 'src/app/shared/services/toast.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { LocationAccuracy } from "@ionic-native/location-accuracy/ngx";
// import { AndroidPermissions } from "@awesome-cordova-plugins/android-permissions/ngx";
import { Diagnostic } from '@ionic-native/diagnostic/ngx'
import { AddressService } from 'src/app/modules/account/component/add-edit-address/service/address.service';
import { AddressComponent } from 'src/app/modules/account/component/add-edit-address/address.component';
import { NavController } from '@ionic/angular';
import { CacheService } from 'src/app/shared/services/cache.service';

@Component({
  selector: 'app-add-address-on-cart-modal',
  templateUrl: './add-address-on-cart-modal.component.html',
  styleUrls: ['./add-address-on-cart-modal.component.scss'],
})
export class AddAddressOnCartModalComponent extends AddressComponent {

  constructor(
    addressService: AddressService,
    fb: FormBuilder,
    toastService: ToastService,
    router: Router,
    geolocation: Geolocation,
    modalService: NgbModal,
    locationAccuracy: LocationAccuracy,
    diagnostic: Diagnostic,
    // androidPermissions: AndroidPermissions,
    activateRoute: ActivatedRoute,
    navCtrl: NavController,
    cacheService:CacheService
  ) {
    super(addressService, fb, toastService, router, geolocation,modalService, locationAccuracy, diagnostic,activateRoute,navCtrl,cacheService);
  }

}
